import { useContext } from 'react';

import { CheckoutSummaryContext } from '../providers/CheckoutSummaryProvider';

export function useCheckout() {
  const context = useContext(CheckoutSummaryContext);
  if (!context) {
    throw new Error('useCheckout has to be used within <CheckoutSummaryContext.Provider>');
  }
  return context;
}
